import { all } from 'redux-saga/effects';
import editGroupMetaDataSaga from './edit_group_meta_data.saga';
import getGroupOptionsPermissionsSaga from './get_group_options_permissions.saga';
import editGroupModulePermissionsSaga from './edit_group_module_permissions.saga';
import getModelStructureSaga from './get_model_structure.saga';
import editGroupModelPermissionsSaga from './edit_group_model_permissions.saga';
import setAllFieldPermissionSaga from './set_all_field_permission.saga';
import setModulesOptionSaga from './set_module_option.saga';
import filterGroupModuleRequestSaga from './filter_group_module.saga';

export default function* userGroupUpdateRootSaga() {
    yield all([
        filterGroupModuleRequestSaga(),
        setModulesOptionSaga(),
        setAllFieldPermissionSaga(),
        editGroupMetaDataSaga(),
        editGroupModelPermissionsSaga(),
        getGroupOptionsPermissionsSaga(),
        editGroupModulePermissionsSaga(),
        getModelStructureSaga(),
    ]);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/sagas/root.saga.js